import { Button, Modal } from "react-bootstrap";
import { modal } from "@/utils/constant";

function PracticeRunAboutModel({ hide, show, openPracticeRunSessionModel }) {
  const listArray = [
    { text: "4-5 participants" },
    { text: "30-minute time limit" },
    { text: "No team performance scores" },
  ];

  return (
    <Modal show={show} onHide={hide} size="xl" centered restoreFocus={false}>
      <Modal.Header className="bg-secondary" closeButton>
        <Modal.Title>{modal?.PracticeRunModelTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-10 px-lg-14">
        <div className="mb-8 vstack gap-8">
          <p>{modal?.PracticeRunModelText}</p>
        </div>
        <div className="mb-8 vstack gap-8">
          <p>
            {modal?.PracticeRunModelTextUL}
            {
              <ul className="list-disc ps-5">
                {listArray.map((item, index) => (
                  <li key={index} className="mb-2">
                    {item.text}
                  </li>
                ))}
              </ul>
            }
          </p>
        </div>
        <div className="mb-8 vstack gap-8">
          <p>
            <b>Please note: </b>
            {modal?.PracticeRunModelText2}
          </p>
        </div>
        <Button
          variant='secondary'
          size='xl'
          className='mt-10 mb-3 justify-content-center d-flex mx-auto font-semibold'
          type='button'
          onClick={openPracticeRunSessionModel}
        >
          {modal?.PracticeRunModelButtonText}
        </Button>
      </Modal.Body>
    </Modal>
  );
}
export default PracticeRunAboutModel;
